import { Component, Input, OnInit } from '@angular/core';
import { SpecialDiffType } from '@conpulse-web/core';

@Component({
  selector: 'conpulse-web-special-diff',
  templateUrl: './special-diff.component.html',
  styleUrls: ['./special-diff.component.scss'],
})
export class SpecialDiffComponent {
  @Input() type: SpecialDiffType = SpecialDiffType.DEFAULT;
  @Input() set leftHandSide(value: string) {
    this.leftSideText = value || '';
    this.computeDiff();
  }
  @Input() set rightHandSide(value: string) {
    this.rightSideText = value || '';
    this.computeDiff();
  }
  private leftSideText = '';
  private rightSideText = '';
  diffHtml: string = '';

  /**
   * Computes diff between left hand and right hand side
   */
  computeDiff() {
    if (this.leftSideText !== this.rightSideText) {
      switch (this.type) {
        case SpecialDiffType.DEFAULT:
          this.diffHtml = `<del>${this.leftSideText}</del><ins>${this.rightSideText}</ins>`;
          break;
        default:
          this.diffHtml = `<del>${this.leftSideText}</del><ins>${this.rightSideText}</ins>`;
          break;
      }
    } else {
      this.diffHtml = this.leftSideText;
    }
  }
}
